import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Col,
  Modal,
  Row,
  Spin,
  notification,
  Popconfirm,
  Form,
  Input,
  Dropdown,
  Select,
} from "antd";
import _ from "lodash";
import {
  HeartOutlined,
  SaveOutlined,
  ClearOutlined,
  DownOutlined,
  UpOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { BsInfoCircleFill } from "react-icons/bs";
import { GiHighGrass } from "react-icons/gi";
import {
  IoFilter,
  IoGrid,
  IoListOutline,
  IoPrintOutline,
} from "react-icons/io5";
import secureLocalStorage from "react-secure-storage";
import { ModuleContext } from "../../context/Context";
import PracticeCard from "./Components/PracticeCard";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import WizardForm from "../ExplorebyGoals/wizardForm";
import hostURL from "../../Common/constants";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { nextStep, setIsLoading } from "../../Redux/tutorialSlice";
import {
  nextWizardStep,
  prevWizardStep,
  setWizardStep,
  openWizard,
  closeWizard,
  setStartedFromSavedPriorities,
} from "../../Redux/wizardSlice";

import csp from "../../images/basics/CSP.png";
import eqip from "../../images/basics/EQIP.png";
import rcpp from "../../images/basics/RCPP.png";
import { resetFilterState } from "../../utils/resetFilterState";
import { fetchAllPracticeDataByCounty } from "../../Redux/practice/practiceThunk";
import {
  fetchGeoStates,
  fetchGeoCountiesByState,
} from "../../Redux/geo/geoThunk";
import { selectFilterScoredAndSortedPractices } from "../../Redux/practice/practiceSelectors";
import ResponsiveConfirm from "../../Components/ResponsiveConfirm";

const PracticeList = ({
  setPracticeNumber,
  userFavoritePractices,
  setUserFavoritePractices,
}) => {
  const params = useParams();

  const pastSearchData = window.sessionStorage.getItem("pastSearchData")
    ? window.sessionStorage.getItem("pastSearchData")
    : false;
  const pastSearchDataState = pastSearchData
    ? JSON.parse(pastSearchData).selectedState
    : false;
  const pastSearchDataCounty = pastSearchData
    ? JSON.parse(pastSearchData).selectedCounty
    : false;
  const [loading, setLoading] = useState(false);
  const [selIsPastSearch, setselIsPastSearch] = useState(false);
  const [filteredPractices, setFilteredPractices] = useState([]);
  const [filteredPracticesUnsort, setFilteredPracticesUnsort] = useState([]);
  const [filteredPracticesRawData, setFilteredPracticesRawData] = useState([]);
  const [statecrepPracticesData, setStatecrepPracticesData] = useState([]);
  const [filteredPracticesPriorities, setFilteredPracticesPriorities] =
    useState([]);
  const [filteredPracticesNumber, setFilteredPracticesNumber] = useState(0);
  const [notselected, setNotselected] = useState(false);
  const [listView, setListView] = useState("Grid");
  const [isSavePopOpen, setIsSavePopOpen] = useState(false);
  const [disclaimerModal, setDisclaimerModal] = useState(false);
  const [initialLoadingDone, setInitialLoadingDone] = useState(false);
  const hasMountedRef = useRef(false);
  const dispatch = useDispatch();
  const isTutorialActive = useSelector(
    (state) => state.tutorial.isTutorialActive
  );
  const {
    wizardStep,
    open: isWizardOpen,
    startedFromSavedPriorities,
  } = useSelector((state) => state.wizard);
  const [userFavoritesLoaded, setUserFavoritesLoaded] = useState(false);
  const {
    landCoverSelections,
    prioritySelections,
    rankingScore,
    selectedState,
    selectedCounty,
  } = useSelector((state) => state.filter);
  const [selectedSignUps, setSelectedSignUps] = useState(["G", "C", "Grslnd"]);
  const [selectedActivity, setSelectedActivity] = useState(undefined);

  const signupsList = [
    { label: "General", value: "G" },
    { label: "Continuous", value: "C" },
    { label: "Grassland", value: "Grslnd" },
  ];

  const isLoggedIn = secureLocalStorage.getItem("token");

  const visiblePractices = useSelector(selectFilterScoredAndSortedPractices);

  const prev = () => {
    dispatch(prevWizardStep());
  };

  const printPracticeArray = [];

  const handleMenuClick = (e) => {
    if (e.key === "1") setListView("Grid");
    if (e.key === "2") setListView("List");
    if (e.key === "3") {
      const printFilterOptions = {
        landCover: landCoverSelections,
        priorities: prioritySelections,
        state: selectedState,
        county: selectedCounty,
      };
      secureLocalStorage.setItem(
        "printPracticeData",
        JSON.stringify(printPracticeArray)
      );
      secureLocalStorage.setItem(
        "printFilterSelections",
        JSON.stringify(printFilterOptions)
      );
      window.open("/PracticeList/Print", "_blank", "rel=noopener noreferrer");
    }
  };

  const items = [
    {
      label: "Grid View",
      key: "1",
      icon: <IoGrid />,
    },
    {
      label: "List View",
      key: "2",
      icon: <IoListOutline />,
    },
    {
      label: "Print View",
      key: "3",
      icon: <IoPrintOutline />,
    },
  ];

  useEffect(() => {
    const isPastSearch =
      window.location.pathname.endsWith("/pastSearch") ||
      secureLocalStorage.getItem("IsPastSearch");

    setselIsPastSearch(isPastSearch);
  }, []);

  const handleConfirm = () => {
    if (isTutorialActive) {
      dispatch(setIsLoading(true));
      dispatch(closeWizard());
      setTimeout(() => {
        dispatch(nextStep());
        dispatch(setIsLoading(false));
        console.log("HANDLE CONFIRM SET LOADING TO FALSE");
      }, 400);
    } else dispatch(closeWizard());
  };

  const next = useCallback(() => {
    dispatch(setIsLoading(true));
    if (selectedState != null && selectedCounty != null) {
      setNotselected(false);
      dispatch(nextWizardStep());
      setTimeout(() => {
        dispatch(nextStep());
        dispatch(setIsLoading(false));

        console.log("NEXT SET LOADING TO FALSE");
      }, 400);
    } else {
      dispatch(setIsLoading(false));

      console.log("NEXT SET LOADING TO FALSE");
      setNotselected(true);
    }
  }, [selectedState, selectedCounty]);

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, title, message) => {
    api[type]({
      message: title,
      description: message,
    });
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };
  const gotoTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const navigate = useNavigate();

  const getLabels = {
    winderosion: "Wind Erosion",
    watererosion: "Water Erosion",
    soilhealth: "Soil Health",
    excesswind: "Excess Wind",
    drought: "Drought",
    // elevatedwatertemperature: "Water Temperature",
    flooding: "Flooding",
    snowdrift: "Snow Drift",
    waterquality: "Water Quality",
    aquatic: "Aquatic",
    biggame: "Big Game",
    grasslandbirds: "Grassland Birds",
    forestbirds: "Forest Birds",
    pollinators: "Pollinators",
    waterfowl: "Waterfowl",
    carbonstorage: "Carbon Storage",
    priorityecosystem: "Ecosystem",
    aquaculture: "Aquaculture Ponds",
    cropland: "Cropland",
    // timber: "Timber",
    pasture: "Pasture",
    wetland: "Wetland",
  };

  const authToken = secureLocalStorage.getItem("token");

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
    if (!startedFromSavedPriorities && !isTutorialActive) {
      dispatch(openWizard());
    } else {
      dispatch(setStartedFromSavedPriorities(false));
    }
  }, []);

  // useEffect(() => {
  //   if (selIsPastSearch && pastSearchData) {
  //     const parsedData = JSON.parse(pastSearchData);
  //     dispatch(setSelectedState(parsedData.selectedState));
  //     dispatch(setSelectedCounty(parsedData.selectedCounty));
  //     dispatch(setLandCoverSelections(parsedData.landCoverSelections));
  //     dispatch(setPrioritySelections(parsedData.prioritySelections));
  //   }
  // }, [isPastSearch, pastSearchData, dispatch]);

  useEffect(() => {
    if (!selectedState && !selectedCounty && wizardStep > 0)
      dispatch(setWizardStep(0));
  }, [dispatch, selectedCounty, selectedState, wizardStep]);

  useEffect(() => {
    dispatch(fetchGeoStates());
  }, []);

  const storeSearchData = (values, sroute) => {
    const searchedData = {
      selectedState,
      selectedCounty,
      landCoverSelections,
      prioritySelections,
      rankingScore,
    };
    setIsSavePopOpen(false);
    const formData = {
      userId: secureLocalStorage.getItem("userRef"),
      route: window.location.href,
      subRoute: sroute,
      formData: JSON.stringify(searchedData),
      stype: "explorePractices",
      mySearchName: values.SaveKey,
    };

    setLoading(true);
    fetch(hostURL + "api/usersearchdata", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: authToken,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((json) => {
        setLoading(false);
        openNotificationWithIcon(
          "success",
          "Success",
          "Saved Your Search Criteria"
        );
      })
      .catch((error) => {
        setLoading(false);
        openNotificationWithIcon("error", "Error", "Try Again Later");
      });
  };

  const getUserFavorites = () => {
    fetch(
      `${hostURL}api/userfavourite/${secureLocalStorage.getItem(
        "userRef"
      )}/${selectedState}/${selectedCounty}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: authToken,
        },
      }
    )
      .then(async (response) => {
        const json = await response.json();

        if (!response.ok) {
          throw new Error(json.message || "Failed to fetch favorites.");
        }

        const rawFavorites = Array.isArray(json)
          ? json.map((item) => item.favTitle)
          : Array.isArray(json.data)
          ? json.data.map((item) => item.favTitle)
          : [];

        const respData = Array.from(new Set(rawFavorites));
        setUserFavoritePractices(respData);
      })
      .catch((error) => {
        setUserFavoritePractices([]);
        openNotificationWithIcon(
          "error",
          "Session Expired",
          "Please log in again to view favorites."
        );
      });
  };

  useEffect(() => {
    if (
      !isLoggedIn ||
      (!selectedState && !selectedCounty && isLoggedIn && !userFavoritesLoaded)
    ) {
      setUserFavoritesLoaded(true);
      return;
    }

    if (!selectedState && !selectedCounty && selIsPastSearch) {
      setselIsPastSearch(false);
    }

    if (selectedState && selectedCounty && isLoggedIn && !userFavoritesLoaded) {
      getUserFavorites();
      setUserFavoritesLoaded(true);
    }
  }, [selectedState, selectedCounty, isLoggedIn]);

  const prevRankingScoreRef = useRef(null);
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (isTutorialActive) {
      if (!Array.isArray(rankingScore) || rankingScore.length !== 3) {
        return; // Ensure rankingScore has exactly 3 elements before proceeding
      }
      const prevRankingScore = prevRankingScoreRef.current;
      // Function to check if two arrays contain the same objects in the same order
      const arraysAreEqual = (arr1, arr2) => {
        if (!arr1 || arr1.length !== arr2.length) return false; // Ensure both are valid

        return arr1.every((item, index) => {
          const otherItem = arr2[index];
          return (
            item.priority === otherItem.priority &&
            item.score === otherItem.score
          );
        });
      };

      // Skip the first time rankingScore is populated
      if (!hasInitialized.current) {
        hasInitialized.current = true; // Mark as initialized
        prevRankingScoreRef.current = [...rankingScore];
        return;
      }

      if (!arraysAreEqual(prevRankingScore, rankingScore)) {
        dispatch(setIsLoading(true));
        setTimeout(() => {
          dispatch(nextStep());
          dispatch(setIsLoading(false));

          console.log("ARRAY NOT EQUAL SET LOADING TO FALSE");
        }, 400);

        prevRankingScoreRef.current = [...rankingScore];
      }
    }
  }, [rankingScore, isTutorialActive]);

  useEffect(() => {
    if (
      isTutorialActive &&
      wizardStep === 1 &&
      landCoverSelections.length > 0
    ) {
      dispatch(setIsLoading(true));
      setTimeout(() => {
        dispatch(nextStep());
        dispatch(setIsLoading(false));
      }, 400);

      console.log("LANDCOVER SELECTIONS SET LOADING TO FALSE");
    }
  }, [isTutorialActive, wizardStep, landCoverSelections]);

  useEffect(() => {
    if (
      isTutorialActive &&
      wizardStep === 2 &&
      prioritySelections.length === 3
    ) {
      dispatch(setIsLoading(true));
      setTimeout(() => {
        dispatch(nextStep());
        dispatch(setIsLoading(false));
      }, 400);

      console.log("PRIOROITY SELECTIONS SET LOADING TO FALSE");
    }
  }, [prioritySelections, isTutorialActive, wizardStep]);

  const getPracticeReport = () => {
    navigate("/PracticeReport");
  };

  const favOnchange = (val, title) => {
    const pTitle = title.split("#")[0];
    const pLink = title.split("#")[1];
    if (val === 1) {
      const formData = {
        userId: secureLocalStorage.getItem("userRef"),
        favTitle: pTitle,
        favPdfLink: pLink,
        state: selectedState,
        county: selectedCounty,
      };

      setLoading(true);
      fetch(hostURL + "api/userfavourite", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify(formData),
      })
        .then(async (response) => {
          const json = await response.json();

          if (!response.ok) {
            throw new Error(json.message || "Failed to save favorite.");
          }

          console.log("Added to favorites response:", json);
          getUserFavorites();
          openNotificationWithIcon(
            "success",
            // "Success",
            "Added to Favorites"
          );
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          openNotificationWithIcon(
            "error",
            "Session Expired",
            "Please log in again to save favorites."
          );
        });
    } else if (val === 0) {
      const formData = {
        userId: secureLocalStorage.getItem("userRef"),
        favTitle: pTitle,
        state: selectedState,
        county: selectedCounty,
      };

      setLoading(true);
      fetch(
        `${hostURL}api/userfavourite/${formData.userId}/${formData.favTitle}/${formData.state}/${formData.county}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: authToken,
          },
          body: JSON.stringify(formData),
        }
      )
        .then(async (response) => {
          const json = await response.json();

          if (!response.ok) {
            if (response.status === 401) {
              secureLocalStorage.removeItem("token");
              secureLocalStorage.removeItem("refreshToken");
              openNotificationWithIcon(
                "error",
                "Session Expired",
                "Please log in again to manage favorites."
              );
            } else {
              throw new Error(json.message || "Failed to remove favorite.");
            }
            return;
          }

          console.log("Removed from favorites response:", json);
          getUserFavorites();
          notification.success({
            description: "Removed from Favorites",
            icon: <DeleteOutlined style={{ color: "#faad14" }} />,
          });
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          openNotificationWithIcon(
            "error",
            "Error",
            error.message || "Try Again Later"
          );
        });
    }
  };

  const resetFilterSearch = () => {
    window.sessionStorage.removeItem("pastSearchData");
    window.location.reload();
  };

  const lastFetchRef = useRef({ state: null, county: null });

  useEffect(() => {
    console.log("🔥 userFavoritePractices updated:", userFavoritePractices);
  }, [userFavoritePractices]);

  useEffect(() => {
    if (selectedState && selectedCounty) {
      if (
        !hasMountedRef.current ||
        lastFetchRef.current.state !== selectedState ||
        lastFetchRef.current.county !== selectedCounty
      ) {
        lastFetchRef.current = { state: selectedState, county: selectedCounty };
        hasMountedRef.current = true;
        dispatch(fetchAllPracticeDataByCounty());
      }
    }
  }, [selectedState, selectedCounty, dispatch]);

  const getMatchLabel = (score) => {
    if (!score) return null;
    const ranges = {
      0: [
        { min: 3, label: "Best Match", className: "practice-best-match" },
        { min: 2, label: "Good Match", className: "practice-good-match" },
        { min: 1, label: "Fair Match", className: "practice-fair-match" },
      ],
      1: [
        {
          min: 1,
          max: 1,
          label: "Fair Match",
          className: "practice-fair-match",
        },
        {
          min: 2,
          max: 2,
          label: "Good Match",
          className: "practice-good-match",
        },
        {
          min: 3,
          max: 3,
          label: "Best Match",
          className: "practice-best-match",
        },
      ],
      2: [
        {
          min: 0.75,
          max: 2.25,
          label: "Fair Match",
          className: "practice-fair-match",
        },
        {
          min: 2.26,
          max: 3.75,
          label: "Good Match",
          className: "practice-good-match",
        },
        {
          min: 3.76,
          max: 5.25,
          label: "Best Match",
          className: "practice-best-match",
        },
      ],
      3: [
        {
          min: 0.5,
          max: 2.5,
          label: "Fair Match",
          className: "practice-fair-match",
        },
        {
          min: 2.6,
          max: 5.0,
          label: "Good Match",
          className: "practice-good-match",
        },
        {
          min: 5.1,
          max: 6.75,
          label: "Best Match",
          className: "practice-best-match",
        },
      ],
      4: [
        {
          min: 0.25,
          max: 2.75,
          label: "Fair Match",
          className: "practice-fair-match",
        },
        {
          min: 2.76,
          max: 5.5,
          label: "Good Match",
          className: "practice-good-match",
        },
        {
          min: 5.6,
          max: 10,
          label: "Best Match",
          className: "practice-best-match",
        },
      ],
    };

    const totSelectedPriorities = prioritySelections
      ? prioritySelections.length
      : 0;

    const conditionsCheck =
      ranges[totSelectedPriorities >= 4 ? 4 : totSelectedPriorities];
    if (!conditionsCheck) return null;

    for (const condition of conditionsCheck) {
      if (
        score >= condition.min &&
        (condition.max === undefined || score <= condition.max)
      ) {
        return {
          scoreLabel: condition.label,
          scoreClassName: condition.className,
        };
      }
    }

    return null;
  };

  const prevFilteredPrioritiesRef = useRef(null);

  useEffect(() => {
    if (
      filteredPractices &&
      filteredPracticesPriorities.length > 0 &&
      rankingScore.length > 0
    ) {
      if (!filteredPractices || filteredPractices.length === 0) return;

      const prioritiesUnchanged =
        JSON.stringify(prevFilteredPrioritiesRef.current) ===
        JSON.stringify(filteredPracticesPriorities);

      const rankingUnchanged =
        JSON.stringify(prevRankingScoreRef.current) ===
        JSON.stringify(rankingScore);

      if (prioritiesUnchanged && rankingUnchanged) {
        return; // Skip if no change
      }

      prevFilteredPrioritiesRef.current = filteredPracticesPriorities;
      prevRankingScoreRef.current = [...rankingScore];

      let filteredPracticesScores = filteredPracticesPriorities.map((data) => {
        const multipliers = [1, 0.75, 0.5, 0.25];

        let totalScoreArray = rankingScore.map((item, index) => {
          const itemPriorityRating = filteredPracticesRawData.find((item) =>
            item.hasOwnProperty(data.pnumber)
          );
          const itemScoreValue = itemPriorityRating
            ? parseFloat(itemPriorityRating.priorityrating[item.priority])
            : 0;
          const score = data[item.priority] ? itemScoreValue : 0;
          const ratingMultiplier =
            multipliers[index] !== undefined ? multipliers[index] : 0.25;
          return score * ratingMultiplier;
        });

        let totalScore = totalScoreArray.reduce((a, b) => {
          return a + b;
        }, 0);

        return {
          pnumber: data.pnumber,
          score: totalScore,
        };
      });

      let scoredFilteredPractices = filteredPractices.map((practice) => {
        let scoreArray = filteredPracticesScores.filter(
          (item) => item.pnumber === practice.title.split("-")[0].trim()
        );
        const score = scoreArray.length > 0 ? scoreArray[0].score : 0;

        const match =
          score > 0 && getMatchLabel(score)
            ? getMatchLabel(score)
            : { scoreLabel: "", scoreClassName: "" };

        const result = {
          title: practice.title,
          pdflink: practice.pdflink || "undefined",
          notes: practice.notes,
          score: score,
          ...(prioritySelections.length > 0 && {
            scoreLabel: match.scoreLabel,
          }),
          ...(prioritySelections.length > 0 && {
            scoreClassName: match.scoreClassName,
          }),
        };

        return result;
      });

      const sortedFilterData = reorderMatches(scoredFilteredPractices);
      setFilteredPractices(sortedFilterData);
    }
  }, [rankingScore, filteredPracticesPriorities]);

  const reorderMatches = (scoredFilteredPracticesData) => {
    const sortOrder = {
      "Best Match": 1,
      "Good Match": 2,
      "Fair Match": 3,
    };

    if (scoredFilteredPracticesData && prioritySelections.length > 0) {
      const sortedData = [...scoredFilteredPracticesData].sort((a, b) => {
        const scoreA = a.scoreLabel ? sortOrder[a.scoreLabel] || 4 : 4;
        const scoreB = b.scoreLabel ? sortOrder[b.scoreLabel] || 4 : 4;
        
        // If match labels are identical, fall back to numeric score comparison
        if (scoreA === scoreB) {
          return (b.score || 0) - (a.score || 0);
        }
        return scoreA - scoreB;
      });
      return sortedData;
    } else {
      return filteredPracticesUnsort;
    }
  };

  const [form] = Form.useForm();

  const showPopconfirm = () => {
    setIsSavePopOpen(true);
  };
  const disclaimerModalClose = () => {
    setDisclaimerModal(false);
  };

  const saveSearchPopClose = () => {
    form.resetFields();
    setIsSavePopOpen(false);
  };

  const checkEligibility = () => {
    secureLocalStorage.setItem("IsPastSearch", true);
    navigate("/Map");
  };

  const renderPracticeCards = () => {
    let firstCardAssigned = false;
    let visiblePracticeCount = 0;

    const crepColorPool = [
      "#8e44ad",
      "#e67e22",
      "#3498db",
      "#27ae60",
      "#e74c3c",
    ];
    const crepColorMap = new Map();
    let nextColorIndex = 0;
    let filteredVisiblePractices = [];
    let generalVisiblePractices = [];
    let continuousVisiblePractices = [];
    let grasslandVisiblePractices = [];

    if (selectedSignUps.length) {
      const practiceSource =
        filteredPractices && filteredPractices.length > 0
          ? filteredPractices
          : visiblePractices;

      // Filter in a single pass over practiceSource to preserve ranked order
      filteredVisiblePractices = practiceSource.filter((practice) => {
        const isGeneral = selectedSignUps.includes("G") && practice.general;
        const isContinuous =
          selectedSignUps.includes("C") &&
          practice.continuous &&
          practice.continuous !== "false";
        const isGrassland =
          selectedSignUps.includes("Grslnd") && practice.title.includes("88");

        return isGeneral || isContinuous || isGrassland;
      });

      // Deduplicate by title while maintaining array order
      filteredVisiblePractices = [
        ...new Map(
          filteredVisiblePractices.map((item) => [item.title, item])
        ).values(),
      ];
    };

    filteredVisiblePractices?.forEach((practice) => {
      practice.crepInfo?.forEach((crep) => {
        const title = crep.crepname;
        if (!crepColorMap.has(title)) {
          crepColorMap.set(
            title,
            crepColorPool[nextColorIndex % crepColorPool.length]
          );
          nextColorIndex++;
        }
      });
    });

    let practiceCols =
      filteredVisiblePractices &&
      filteredVisiblePractices.length > 0 &&
      filteredVisiblePractices.map((practice) => {
        const matchingPrioritiesArray = filteredPracticesPriorities.filter(
          (priorityData) =>
            priorityData.pnumber === practice.title.split("-")[0].trim()
        );
        const matchingPriorities =
          matchingPrioritiesArray.length > 0
            ? matchingPrioritiesArray[0]
            : null;

        const matchingPrioritiesList = matchingPriorities
          ? Object.keys(matchingPriorities).filter(
              (key) => matchingPriorities[key] === true
            )
          : [];

        const landCoverIntersection =
          matchingPrioritiesList.length > 0
            ? matchingPrioritiesList.filter((landcover) =>
                landCoverSelections.includes(landcover)
              )
            : [];

        const priorityIntersection =
          matchingPrioritiesList.length > 0
            ? matchingPrioritiesList.filter((priority) =>
                prioritySelections.includes(priority)
              )
            : [];

        let showPracticeCard = false;

        if (landCoverSelections.length > 0 && prioritySelections.length > 0) {
          showPracticeCard =
            priorityIntersection.length > 0 && landCoverIntersection.length > 0;
        } else if (landCoverSelections.length > 0) {
          showPracticeCard = landCoverSelections.some((type) =>
            matchingPrioritiesList.includes(type)
          );
        } else if (
          prioritySelections.length > 0 &&
          landCoverSelections.length > 0
        ) {
          showPracticeCard = landCoverIntersection.length > 0;
        } else if (
          landCoverSelections.length === 0 &&
          prioritySelections.length > 0
        ) {
          showPracticeCard = priorityIntersection.length > 0;
        } else if (
          practice.title.split("-")[1]?.trim().toLowerCase().endsWith("crep")
        ) {
          showPracticeCard = false;
        } else {
          showPracticeCard = true;
        }

        visiblePracticeCount++;

        const isFirstCard = !firstCardAssigned;
        if (isFirstCard) firstCardAssigned = true;

        return (
          <Col
            className="toOverrideAntD"
            span={listView === "List" ? 12 : 5}
            key={practice.title}
          >
            <PracticeCard
              mode="explore_practices"
              disableInteractions={false}
              crepColorMap={crepColorMap}
              listView={listView}
              practice={practice}
              layout="vertical"
              selectable={false}
              userFavoritePractices={userFavoritePractices}
              favOnchange={favOnchange}
              isFirstCard={isFirstCard}
              data-practice-title={practice.title}
            />
          </Col>
        );
      });

    if (!practiceCols) {
      practiceCols = [];
    }

    return { practiceCols, visiblePracticeCount };
  };

  const { practiceCols, visiblePracticeCount } = useMemo(() => {
    return renderPracticeCards();
  }, [
    visiblePractices,
    statecrepPracticesData,
    landCoverSelections,
    prioritySelections,
    selIsPastSearch,
    userFavoritePractices,
    listView,
    selectedSignUps,
    selectedActivity,
  ]);

  useEffect(() => {
    setInitialLoadingDone(false);
    const timeout = setTimeout(() => {
      setInitialLoadingDone(true);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [selectedState, selectedCounty]);

  useEffect(() => {
    if (initialLoadingDone) {
      const list = document.querySelector(".practice-list");
      if (list) {
        list.scrollTop += 1;
        setTimeout(() => {
          list.scrollTop -= 1;
        }, 50);
      }
    }
  }, [initialLoadingDone]);

  const handleSignupChange = (value) => {
    setSelectedSignUps(value);
  };

  return (
    <>
      <Header />
      {contextHolder}
      <Spin spinning={loading}>
        <Modal
          centered={true}
          className={
            selIsPastSearch ? "filter-modal past-search-modal" : "filter-modal"
          }
          open={isWizardOpen}
          width="80vw"
          onOk={() => {
            dispatch(closeWizard());
          }}
          onCancel={() => {
            dispatch(closeWizard());
          }}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          footer={[
            !selIsPastSearch && wizardStep > 0 ? (
              <Button
                style={{
                  margin: "0 8px",
                }}
                onClick={() => prev()}
              >
                Back
              </Button>
            ) : (
              ""
            ),
            !selIsPastSearch && wizardStep < 3 ? (
              <Button
                className="location-sel-next"
                style={{ float: "right" }}
                type="primary"
                onClick={() => next()}
              >
                Next
              </Button>
            ) : (
              ""
            ),
            !selIsPastSearch && wizardStep === 3 ? (
              <Button
                className="confirm-tutorial"
                style={{ float: "right" }}
                type="primary"
                onClick={() => handleConfirm()}
              >
                Confirm
              </Button>
            ) : (
              ""
            ),
            selIsPastSearch ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginBottom: "30px",
                  marginTop: "10px",
                }}
              >
                <Button
                  className="confirm-tutorial"
                  type="primary"
                  onClick={() => {
                    setselIsPastSearch(false);
                    // navigate("/PracticeList");
                  }}
                >
                  Edit
                </Button>
              </div>
            ) : (
              ""
            ),
            selIsPastSearch ? (
              <div style={{ marginBottom: "30px", marginTop: "10px" }}>
                <Button
                  className="confirm-tutorial"
                  type="primary"
                  onClick={() => {
                    setselIsPastSearch(false);
                    dispatch(closeWizard());
                  }}
                >
                  Confirm
                </Button>
              </div>
            ) : (
              ""
            ),
          ]}
        >
          {!selIsPastSearch ? (
            <>
              <WizardForm
                className="filter-wizard-form"
                notselected={notselected}
              />
            </>
          ) : (
            <>
              <Row className="mt-1">
                <div className="selection-modal">
                  <h3>You have previously selected:</h3>
                  <ul>
                    <li>
                      <b>State: </b>
                      <b style={{ color: "maroon" }}>{selectedState}</b>
                    </li>
                    <li>
                      <b>County: </b>
                      <b style={{ color: "maroon" }}>{selectedCounty}</b>
                    </li>
                    <li>
                      <b>Land Cover Types: </b>
                      <b style={{ color: "maroon" }}>
                        {landCoverSelections
                          .map((item) => getLabels[item])
                          .join(", ")}
                      </b>
                    </li>
                    <li>
                      <b>Priorities: </b>
                      <b style={{ color: "maroon" }}>
                        {prioritySelections
                          .map((item) => getLabels[item])
                          .join(", ")}
                      </b>
                    </li>
                  </ul>
                </div>
                <p>
                  Would you like to continue with these selections? Click{" "}
                  <b>"Edit"</b> to make changes to these selections. Click{" "}
                  <b>"Confirm"</b> to proceed with these selections.
                </p>
              </Row>
            </>
          )}
        </Modal>
        <div
          className="practice-list"
          style={{ display: "flex", flexDirection: "column", width: "100%" }}
        >
          <div className="filter-container" style={{ width: "90%" }}>
            <div className="filter-buttons-container">
              <Button
                className="filter-button filter-button-tutorial"
                onClick={() => {
                  setselIsPastSearch(false);
                  dispatch(openWizard());
                }}
              >
                <b>
                  <IoFilter /> Filters
                </b>
              </Button>

              <ResponsiveConfirm
                title="Clear Filters"
                description="Are you sure you want to clear the filter results and start over?"
                onConfirm={() => resetFilterState(dispatch)}
                confirmText="Yes"
                cancelText="No"
              >
                <Button className="filter-button reset-button-tutorial">
                  <b>
                    <ClearOutlined /> Start Over
                  </b>
                </Button>
              </ResponsiveConfirm>
            </div>

            <div className="filter-results">
              {selectedCounty && (
                <h3>{`Location: ${selectedCounty}, ${selectedState}`}</h3>
              )}
              <h3>
                Available Practices:&nbsp;
                {visiblePracticeCount}
              </h3>

              <h3>
                {landCoverSelections.length
                  ? "Selected Land Cover Types: "
                  : null}
                {landCoverSelections.map((type) => (
                  <b className="filter-tag">{getLabels[type]}</b>
                ))}
              </h3>
              <h3>
                {prioritySelections.length ? "Selected Priorities: " : null}
                {prioritySelections.map((type) => (
                  <b className="filter-tag">{getLabels[type]}</b>
                ))}
              </h3>
            </div>

            <div className="filter-options-container">
              <div className="select-signup-container">
                <label style={{ fontWeight: "bolder" }}>Signup Types </label>
                <Select
                  mode="multiple"
                  className="select-font-size sel-sgnup"
                  defaultValue={selectedSignUps}
                  placeholder="Select Signup"
                  onChange={handleSignupChange}
                  options={signupsList}
                  value={selectedSignUps}
                />
              </div>
              {/* <Select
                className="select-font-size sel-sgnup"
                defaultValue={selectedActivity}
                placeholder="Select Activity"
                onChange={handleActivityChange}
                options={activitiesList}
                value={selectedActivity}
              /> */}
              <Dropdown menu={menuProps} trigger={["click"]}>
                <div
                  onClick={(e) => e.preventDefault()}
                  className="list-view-button list-view-tutorial"
                >
                  <div className="list-view-button-div">
                    {listView === "List" ? (
                      <IoListOutline size={20} />
                    ) : listView === "Grid" ? (
                      <IoGrid />
                    ) : (
                      <IoPrintOutline />
                    )}
                    <b>{` ${listView} View`}</b>
                  </div>
                  <DownOutlined />
                </div>
              </Dropdown>
              <Button
                className="list-view-button tutorial-ce-button"
                onClick={checkEligibility}
              >
                <b>
                  <GiHighGrass /> Check Field Eligibility
                </b>
              </Button>
              <Row>
                {isLoggedIn !== null && wizardStep === 3 && (
                  <Button className="list-view-button" onClick={showPopconfirm}>
                    <b>
                      <SaveOutlined /> Save Priorities
                    </b>
                  </Button>
                )}
                {isLoggedIn !== null && (
                  <Button className="list-view-button" href="/UserProfile">
                    <b>
                      <HeartOutlined /> Favorite Practices
                    </b>
                  </Button>
                )}
              </Row>
            </div>
          </div>

          {!initialLoadingDone || !userFavoritesLoaded ? (
            <Row justify="center" className="filter-practice-row">
              <Col justify="center" style={{ textAlign: "center" }} span={24}>
                <Spin tip="Loading practices..." size="large" />
                <p className="loading-text">Loading practices</p>
              </Col>
            </Row>
          ) : visiblePracticeCount > 0 ? (
            <Row
              justify="center"
              className={
                listView === "List"
                  ? "filter-practice-row list-view"
                  : "filter-practice-row"
              }
            >
              {practiceCols}
            </Row>
          ) : selectedState && selectedCounty ? (
            <Row
              gutter={[16, 16]}
              justify="center"
              style={{ textAlign: "center", marginTop: "1rem" }}
            >
              <Col span={24}>
                <h2 className="practice-none">
                  {visiblePractices.length > 0 && selectedSignUps.length === 0
                    ? "Sorry, no matching practice found. Please select at least one type of signup to view practices."
                    : "Sorry, no matching practice found. Please click the filter button to choose more land cover types or conservation priorities."}
                </h2>
              </Col>
              {/* <Col xs={24} md={7} xl={7}>
                <a
                  href="https://www.nrcs.usda.gov/programs-initiatives/csp-conservation-stewardship-program"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img className="program-photo" src={csp} alt="CSP" />
                </a>
              </Col>
              <Col xs={24} md={7} xl={7}>
                <a
                  href="https://www.nrcs.usda.gov/programs-initiatives/eqip-environmental-quality-incentives"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img className="program-photo" src={eqip} alt="EQIP" />
                </a>
              </Col>
              <Col xs={24} md={7} xl={7}>
                <a
                  href="https://www.nrcs.usda.gov/programs-initiatives/rcpp-regional-conservation-partnership-program"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img className="program-photo" src={rcpp} alt="RCPP" />
                </a>
              </Col> */}
            </Row>
          ) : (
            <div
              style={{
                padding: "1rem",
                textAlign: "center",
                fontSize: "1.1rem",
                color: "gray",
              }}
            >
              Please select a state and county to get started.
            </div>
          )}

          <Modal
            centered={true}
            title="Save My Search"
            open={isSavePopOpen}
            onOk={null}
            footer={null}
            onCancel={saveSearchPopClose}
          >
            <Form
              name="basic"
              labelCol={{
                span: 8,
              }}
              form={form}
              wrapperCol={{
                span: 16,
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={storeSearchData}
              autoComplete="off"
            >
              <Form.Item
                label="Save Search"
                name="SaveKey"
                rules={[
                  {
                    required: true,
                    message: "Please input your Save Search!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                wrapperCol={{
                  offset: 8,
                  span: 16,
                }}
              >
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Modal>
          <Modal
            centered={true}
            title="Priority Ranking Calculation"
            open={disclaimerModal}
            className="disclaimer-modal"
            onOk={null}
            footer={null}
            onCancel={disclaimerModalClose}
          >
            <p style={{ marginLeft: 10 }}>
              Ranking System: The priorities of each practice are scored on a
              scale of 0-3, depending on how closely the practice addresses the
              priority. User provided rankings will assign weights to each
              priority, which are used to score and generate Best, Good, and
              Fair Matches.
            </p>
          </Modal>
        </div>
        <h5 className="practice-list-disclaimer">
          <BsInfoCircleFill />{" "}
          <a
            className="disclaimer-label"
            onClick={() => setDisclaimerModal(true)}
          >
            <u>Learn More About Priority Ranking Calculation</u>
          </a>
        </h5>
        <Row justify="end">
          <Col>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginBottom: 10,
                marginRight: 50,
              }}
            >
              <Button
                type="primary"
                icon={<UpOutlined />}
                size="large"
                style={{ marginBottom: 10 }}
                onClick={() => gotoTop()}
              />
              <div>
                <b>Back to Top</b>
              </div>
            </div>
          </Col>
        </Row>
        <Footer />
      </Spin>
    </>
  );
};
export default PracticeList;
